import { ThemeEvents, CartUpdateEvent } from '@theme/events';

const GIFT_PROPERTY = '_mova_gift';
const GIFT_FOR_PROPERTY = '_mova_gift_for';

/**
 * Removes any Mova gift line item whose qualifying purchase is no longer in
 * the cart (e.g. the shopper removed the product, or removed just enough
 * units). There can be more than one gift line at once (the Creatina
 * pilot's progressive mode grants up to two for the same purchase), so this
 * prunes every orphaned one in a single pass instead of stopping at the
 * first. Self-terminates: once no gift line is orphaned, the cart:update
 * event this dispatches to refresh the drawer/page finds nothing to prune.
 */
async function pruneOrphanedGifts() {
  let cart;
  try {
    cart = await (await fetch('/cart.js')).json();
  } catch {
    return;
  }

  const giftLines = cart.items.filter((item) => item.properties && item.properties[GIFT_PROPERTY]);
  if (giftLines.length === 0) return;

  const orphaned = giftLines.filter((giftLine) => {
    const triggerVariantId = giftLine.properties[GIFT_FOR_PROPERTY];
    return !cart.items.some(
      (item) => !(item.properties && item.properties[GIFT_PROPERTY]) && String(item.variant_id) === String(triggerVariantId)
    );
  });
  if (orphaned.length === 0) return;

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);

  let updatedCart;
  for (const giftLine of orphaned) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0, sections: sectionIds.join(',') }),
      });
      updatedCart = await response.json();
    } catch {
      return;
    }
  }

  if (updatedCart) {
    document.dispatchEvent(new CartUpdateEvent(updatedCart, 'mova-gift-guard', { sections: updatedCart.sections }));
  }
}

document.addEventListener(ThemeEvents.cartUpdate, pruneOrphanedGifts);
